import Grid from '@mui/material/Grid';
import MethylomeText from './MethylomeText';
import SectionStructure from '../../../../components/Section/SectionStructure';
import DriverCard from '../Longevity/Drivers/DriverCard'


export default function SectionMethylome() {

    
    return (

        <SectionStructure
    
            sectiontext={ <MethylomeText />  }
            sectioncards={ 
            
                <Grid container spacing={2} sx={{display:'flex', justifyContent:'center'}}>   
                   <Grid size={12} sx={{display:'flex', justifyContent:'center'}}>  <DriverCard />  </Grid>
                    <Grid size={12} sx={{display:'flex', justifyContent:'center'}}>    </Grid>
                </Grid>
           }

        />

       
    )
}